import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;

    .courier-revision-row {
        background-color: #fffbe6 !important;
    }

    .courier-revision-row:hover > td {
        background-color: #fff9cc !important;
    }

    @media screen and (max-width: 768px) {
        .ant-table table td {
            display: ${props => props.display};
            grid-template-columns: 1fr 1fr;

            justify-content: center;
            align-items: center;
        }
        .ant-table-cell {
            flex-direction: column;
        }
        .ant-table table th {
            display: none;
        }
        .ant-table table td::before {
            font-weight: bold;
            padding-right: 5px;
        }
        .ant-table table tr td {
            padding: 6px 16px !important;
        }
        .ant-table table tr td:first-child {
            padding-top: 16px !important;
        }
        .ant-table table tr td:last-child {
            padding-bottom: 16px !important;
        }
        .ant-tag {
            padding: 2px 6px !important;
            margin: 0 2px 0 0 !important;
            width: fit-content;
            display: inline-block;
            white-space: nowrap;
        }
        ${props =>
            props.dataTitles.map(
                (title, index) =>
                    `.ant-table table td:nth-child(${index + 1})::before {
                content: "${title}: ";
            }`
            )}
        .ant-table table tr {
            outline: 1px solid #f0f0f0;
            margin-bottom: 20px;
            margin-top: 20px;
            display: block;
            -webkit-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            -moz-box-shadow: 4px 9px 10px 0px rgba(214, 214, 214, 1);
            box-shadow: 0px 4px 4px 0px rgba(214, 214, 214, 1);
        }
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
`;
